import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import RuleNameInput from 'components/Rules/RuleNameInput';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import type { TQuestionRule } from 'types/rules.types';

interface Props {
  rule: TQuestionRule;
  ruleIdx: number;
}

const RuleName = ({ rule, ruleIdx }: Props) => {
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <RuleNameInput
      value={rule.name}
      ruleIdx={ruleIdx}
      isReadOnly={isReadOnly}
      onCommit={(name) => dispatch(upsertQuestionRule({ questionId, rule: { ...rule, name } }))}
    />
  );
};

export default RuleName;
